import React, { useState, useEffect } from "react";

import "./DynamicSolutionDemo.css";

const STEPS = [
    { id: 1, text: "f(x) = (x + 1)²" },
    { id: 2, text: "      = x² + 2x + 1" },
    { id: 3, text: "f'(x) = 2x + 2" },
    { id: 4, text: "       = 2(x + 1)" },
];

const STEP_DURATION_MS = 1800;

const DynamicSolutionDemo = () => {
    const [step, setStep] = useState(0);
    const [direction, setDirection] = useState("forward");

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (direction === "forward") {
                if (step < STEPS.length - 1) {
                    setStep((s) => s + 1);
                } else {
                    setDirection("backward");
                }
            } else {
                if (step > 0) {
                    setStep((s) => s - 1);
                } else {
                    setDirection("forward");
                }
            }
        }, STEP_DURATION_MS);

        return () => clearTimeout(timeout);
    }, [step, direction]);

    return (
        <div className="dynamic-solution-demo" aria-hidden="true">
            <div className="demo-header">
                <button
                    type="button"
                    tabIndex={-1}
                    className={
                        "demo-btn demo-btn--prev" +
                        (direction === "backward" ? " is-active" : "")
                    }
                >
                    ← Previous
                </button>
                <span className="demo-title">Solution</span>
                <button
                    type="button"
                    tabIndex={-1}
                    className={
                        "demo-btn demo-btn--next" +
                        (direction === "forward" ? " is-active" : "")
                    }
                >
                    Next →
                </button>
            </div>
            <div className="demo-body">
                {STEPS.map((entry, i) => {
                    const visible = i <= step;
                    const isCurrent = i === step;
                    return (
                        <div
                            key={entry.id}
                            className={
                                "demo-step" +
                                (visible ? " is-visible" : "") +
                                (isCurrent ? " is-current" : "")
                            }
                        >
                            <span className="demo-step-index">{i + 1}.</span>
                            <span className="demo-step-formula">{entry.text}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DynamicSolutionDemo;
